module.exports = __webpack_public_path__ + "img/lionhearter-white.e082f8c5.png";